import { BitbucketUser } from '@atlassian/cssxp-types-entitlement';
import { Results } from '@atlassian/cssxp-typescommon';

export const userInitialState: any = {
  isSearching: false,
  error: null,
  results: [],
  totalHits: 0,
};
const SEARCH_USERS = 'SEARCH_USERS';
const SEARCH_MORE_USERS = 'SEARCH_MORE_USERS';
const SEARCH_USERS_FAILED = 'SEARCH_USERS_FAILED';

export const fetchInitialUsers = (data: Results<BitbucketUser>) => ({
  type: SEARCH_USERS,
  data,
});

export const fetchUserFailed = (error: Error) => ({
  type: SEARCH_USERS_FAILED,
  error,
});

export const fetchMoreUser = (data: Results<BitbucketUser>) => {
  if (!data) return;

  return {
    type: SEARCH_MORE_USERS,
    data,
  };
};

export const userReducer = (
  state: { results: any },
  action: { type: string; data?: Results<BitbucketUser>; error?: Error } | undefined
) => {
  switch (action?.type) {
    case SEARCH_USERS:
      return action?.data;
    case SEARCH_MORE_USERS: {
      const results = action?.data?.results || [];
      if (results?.length > 0) {
        return {
          ...state,
          results: [...state.results, ...results],
        };
      }
      return state;
    }
    case SEARCH_USERS_FAILED: {
      return {
        ...state,
        error: action?.error,
      };
    }
    default:
      return state;
  }
};
